<table role="presentation" style="width: 100%; text-align: center; border-spacing: 0; border-collapse: collapse;"
    contenteditable="false">
    <tr>
        <td style="padding: 10px;">
            <!-- Banner Upload -->
            <label for="logoUpload" *ngIf="!logoPreview"
                style="cursor: pointer; padding: 8px 16px; border-radius: 4px; background-color: #007bff; color: white; border: none;">
                Upload Logo
            </label>
        </td>
    </tr>
    <tr>
        <td style="padding: 10px;">
            <input id="logoUpload" type="file" (change)="onLogoUpload($event)" accept="image/*" style="display: none;">
        </td>
    </tr>
    <tr>
        <td style="padding: 10px;">
            <img [src]="imgUrl + logoPreview" alt="Company Logo" *ngIf="logoPreview"
                style="max-width: 150px; margin-top: 10px; border-radius: 4px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);">
        </td>
    </tr>
</table>